"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenStax Highlights API
 * The highlights API for OpenStax.  Requests to this API should include `application/json` in the `Accept` header.  The desired API version is specified in the request URL, e.g. `[domain]/highlights/api/v0/highlights`. While the API does support a default version, that version will change over time and therefore should not be used in production code!
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function HighlightFromJSON(json) {
    return HighlightFromJSONTyped(json, false);
}
exports.HighlightFromJSON = HighlightFromJSON;
function HighlightFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'sourceType': json['source_type'],
        'sourceId': json['source_id'],
        'sourceMetadata': !runtime_1.exists(json, 'source_metadata') ? undefined : json['source_metadata'],
        'scopeId': !runtime_1.exists(json, 'scope_id') ? undefined : json['scope_id'],
        'prevHighlightId': !runtime_1.exists(json, 'prev_highlight_id') ? undefined : json['prev_highlight_id'],
        'nextHighlightId': !runtime_1.exists(json, 'next_highlight_id') ? undefined : json['next_highlight_id'],
        'color': json['color'],
        'anchor': json['anchor'],
        'highlightedContent': json['highlighted_content'],
        'annotation': !runtime_1.exists(json, 'annotation') ? undefined : json['annotation'],
        'locationStrategies': json['location_strategies'],
        'orderInSource': !runtime_1.exists(json, 'order_in_source') ? undefined : json['order_in_source'],
    };
}
exports.HighlightFromJSONTyped = HighlightFromJSONTyped;
function HighlightToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'source_type': value.sourceType,
        'source_id': value.sourceId,
        'source_metadata': value.sourceMetadata,
        'scope_id': value.scopeId,
        'prev_highlight_id': value.prevHighlightId,
        'next_highlight_id': value.nextHighlightId,
        'color': value.color,
        'anchor': value.anchor,
        'highlighted_content': value.highlightedContent,
        'annotation': value.annotation,
        'location_strategies': value.locationStrategies,
    };
}
exports.HighlightToJSON = HighlightToJSON;
/**
* @export
* @enum {string}
*/
var HighlightSourceTypeEnum;
(function (HighlightSourceTypeEnum) {
    HighlightSourceTypeEnum["OpenstaxPage"] = "openstax_page";
})(HighlightSourceTypeEnum = exports.HighlightSourceTypeEnum || (exports.HighlightSourceTypeEnum = {}));
/**
* @export
* @enum {string}
*/
var HighlightColorEnum;
(function (HighlightColorEnum) {
    HighlightColorEnum["Yellow"] = "yellow";
    HighlightColorEnum["Green"] = "green";
    HighlightColorEnum["Blue"] = "blue";
    HighlightColorEnum["Purple"] = "purple";
    HighlightColorEnum["Pink"] = "pink";
})(HighlightColorEnum = exports.HighlightColorEnum || (exports.HighlightColorEnum = {}));
